export const capitalize = (s: string) =>
  s.slice(0, 1).toUpperCase().concat(s.slice(1, s.length));

export const removeSlash = (s: string) => s.slice(1, s.length);
